import { resolve } from 'rsvp';
import Ember from 'ember';
import { waitUntil } from '@ember/test-helpers';
const SHEET_CLASS = '.sheet-layout';
const MOVING_ATTRIBUTE = 'data-sheet-is-transitioning';
export const waitForAnimationMocks = {
  waitForSheetAnimation: () => {
    const sheetElem = document.querySelector(SHEET_CLASS);
    if (!sheetElem) {
      return resolve();
    }
    return waitUntil(() => {
      if (Ember.testing) {
        return true;
      }
      return sheetElem && !sheetElem.hasAttribute(MOVING_ATTRIBUTE);
    });
  }
};
export function waitForSheetAnimation() {
  return waitForAnimationMocks.waitForSheetAnimation();
}